import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import type { BadgeProps } from '.';

const fadeInOut = keyframes`
  0%{
    opacity: 1;
  }

  50% {
    opacity: 0;
    color: transparent;
  }
  80% {
  }
  100% {
    opacity: 1;
  }
`;

export const Container = styled.span<BadgeProps>(({ type }) => {
  let backgroundColor = '';
  switch (type) {
    case 'fail':
      backgroundColor = 'RGB(244, 103, 103)';
      break;
    case 'success':
      backgroundColor = 'RGB(40, 198, 171)';
      break;
    default:
      backgroundColor = '#000000';
  }

  return {
    width: '54px',
    height: '20px',
    padding: '1px',
    boxSizing: 'border-box',
    fontSize: '14px',
    lineHeight: '18px',
    textAlign: 'center',
    color: '#ffffff',
    borderRadius: '16px',
    backgroundColor,
    animation: `${fadeInOut} 2s ease`,
    transition: 'background-color 2s ease',
  };
});
